<script>
    export let trans;
    export let filterValues = [];
    export let filter;
    export let componentClass = "";

    function filterImgMapping(type, value) {
        return type.filter((e)=>e.id === value)[0].icon;
    }

    function getShortLabel(type, value) {
        let l = trans(type.filter((e) => e.id === value)[0].label);
        return trans( l.split(" ")[0] )
    }

</script>


<div class="{componentClass} btn-group dropup">
    <button type="button" class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" class:selected={filter !== filterValues[0].id}>
        <img src="img/nicons/{filterImgMapping(filterValues, filter)}"/> <span
            class="filterTag">{getShortLabel(filterValues, filter)}</span> <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">

        {#each filterValues as val (val.id)}
            <li><a on:click={() => {filter=val.id}} href="#" class={val.id}>
                {#if val.icon}<img src="img/nicons/{val.icon}"/>{/if} {trans( val.label)}</a></li>
            {#if val.id === "filterAll"}
                <li role="separator" class="divider"></li>
            {/if}
        {/each}
    </ul>
</div>
